<script>
import ButtonBase from '@/components/helper/add/button-base.vue'
import PopupBase from '@/components/helper/add/popup-base.vue'
import http from '@/plugins/http'
import apiRoute from '@/router/api-routes'

export default {
  name: 'confirm-delete-categ',
  components: {
    PopupBase,
    ButtonBase
  },
  props: {
    categoryId: Number
  },
  data () {
    return {
      loader: false
    }
  },
  methods: {
    deleteCategory () { // DELETE ONE ARTICLE
      this.loader = true
      http.delete(apiRoute.baseURL + apiRoute.deleteCategory + this.categoryId)
        .then(response => {
          console.log(response)
          this.$emit('openSuccessDelete', true)
        }).catch(error => {
          console.log(error)
        })
    },
    goBack () {
      this.$emit('closeDeleteCategory', false)
    }
  }
}
</script>

<template>
  <div class="confirm-delete-categ">
    <popup-base @clickOutside="goBack">
      <div class="begin bg-white m-auto w-1/2 rounded-lg p-8">
        <div class="header flex items-center justify-between">
          <div class="header-title font-medium text-2xl text-black">{{ $t('deleteCategory') }}</div>
          <div class="delete-icon cursor-pointer" @click="goBack">
            <svg-icon name="ic_close" original class="w-4 h-4"/>
          </div>
        </div><br>
        <div class="body mt-6">
          <div class="title">{{ $t('sureDeleteCategory') }}</div><br>
          <div class="delete-button flex items-center justify-end mt-4">
            <div class="deletion">
              <button-base
                :label="$t('deleteButton')"
                :is-loading="loader"
                @click.native="deleteCategory"
              />
            </div>
          </div>
        </div>
      </div>
    </popup-base>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/style/sass/variables";
.deletion::v-deep {
  .button-base {
    .page-button-real {
      background-color: #C43A2B !important;
    }
  }
}
</style>
